module.exports = __webpack_public_path__ + "img/logo.8015ed03.png";